import React, { useState, useEffect } from 'react';
import { GetDocumentListResponse, GetDocumentListResponseData } from '../models/response/document/GetDocumentListResponse';
import { DocumentService } from '../services/DocumentService';
import { MenuComponent } from '../_metronic/assets/ts/components';
import TableActions from './TableActions';
import toast from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { storeActivityIndicator } from '../redux/reducers/authSlice';
import { DownloadReportResponse } from '../models/response/document/DownloadReportResponse';
import { Helpers } from '../helpers/Helpers';

interface DocumentItem {
    isSelected: boolean
    entityId: string
}

interface Props {
    items: DocumentItem[]
    pageName: string
}

const Documents = ({ items, pageName }: Props) => {
    const dispatch = useDispatch();
    const [reports, setReports] = useState<GetDocumentListResponseData[]>([]);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getReports();
    }, [])

    const getReports = async () => {
        try {
            var response: GetDocumentListResponse = await DocumentService.getDocumentList(pageName);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setReports(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
        }
    }

    const downloadReport = async (_menuName: string, _entityId: string | undefined, _documentName: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: DownloadReportResponse = await DocumentService.downloadReport(_menuName, _entityId, _documentName);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.open(Helpers.getEndpoint() + "/Reports/" + response.data, "_blank")
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            {
                reports.length > 0 && (
                    <TableActions
                        title='Evraklar'
                        faIcon='fa-file'
                        list={reports.map(function (x) {
                            return {
                                isDisabled: !(items.filter(x => x.isSelected).length == 1),
                                text: x.name,
                                onClick: () => downloadReport(x.menuName, items.find(x => x.isSelected)?.entityId, x.name)
                            }
                        })}
                    />
                )
            }
        </React.Fragment>
    )
}

export default Documents;